var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMusic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.64 3.232A1 1 0 0 1 20 4v12a1 1 0 1 1-2 0V5.198L9 6.835V18a1 1 0 1 1-2 0V6a1 1 0 0 1 .821-.984l11-2a1 1 0 0 1 .82.216",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2 18.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M16.5 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M13 16.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0",
  clipRule: "evenodd"
})));
export default SvgIcMusic;